import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "devicetype-packetparser"
  }, [_c(VExpansionPanels, {
    staticClass: "my-4 variables",
    attrs: {
      "value": 0,
      "flat": ""
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.typeDefinitionsHeader')) + "\n        ")])]), _c(VExpansionPanelContent, [_c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.typeDefinitionsHelpText'))
    }
  }), _c(VDataTable, {
    attrs: {
      "items": _vm.computedVariables,
      "headers": _vm.variableTableHeaders,
      "hide-default-footer": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', [_c('td', {
          staticStyle: {
            "width": "160px"
          }
        }, [!_vm.readonly ? _c('core-button', {
          attrs: {
            "data-cy": `btn_typedefinitions_down_${items.index}`,
            "color": _vm.color,
            "disabled": _vm.readonly,
            "prepend-icon": "fa-chevron-down"
          },
          on: {
            "click": function ($event) {
              return _vm.changeVariableOrder(items.index, 'down');
            }
          }
        }) : _vm._e(), !_vm.readonly ? _c('core-button', {
          attrs: {
            "data-cy": `btn_typedefinitions_down_${items.item}`,
            "color": _vm.color,
            "disabled": _vm.readonly,
            "prepend-icon": "fa-chevron-up"
          },
          on: {
            "click": function ($event) {
              return _vm.changeVariableOrder(items.item, 'up');
            }
          }
        }) : _vm._e(), _vm._v("\n                #" + _vm._s(_vm.variablesInternal[items.item].order + 1) + "\n              ")], 1), _c('td', [_c('custom-code', [_vm._v(_vm._s(_vm.variablesInternal[items.item].name))])], 1), _c('td', {
          staticStyle: {
            "min-width": "200px"
          }
        }, [_c(VAutocomplete, {
          staticClass: "mb-1",
          attrs: {
            "data-cy": `select_typedefinitions_${items.index}`,
            "items": _vm.parserValueTypes,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "disabled": _vm.formSaving || _vm.readonly,
            "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.selectInList'),
            "hide-details": "auto",
            "item-text": "name",
            "autocomplete": "new-password",
            "return-object": "",
            "dense": ""
          },
          on: {
            "change": function ($event) {
              return _vm.variableTypeSelected(items.item);
            }
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function (data) {
              return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.name))]), _c(VListItemSubtitle, [_vm._v(_vm._s(data.item.descr) + " (" + _vm._s(data.item.group) + ")")])], 1)];
            }
          }], null, true),
          model: {
            value: _vm.variablesInternal[items.item].value_type,
            callback: function ($$v) {
              _vm.$set(_vm.variablesInternal[items.item], "value_type", $$v);
            },
            expression: "variablesInternal[items.item].value_type"
          }
        })], 1)])];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };